import { UnderlineIcon } from "components/common/Icons/UnderlineIcon";
import type { TextBox } from "store/features/memeGenerator/types";
import { useUnderline } from "./useUnderline";

interface UnderlineProps {
    textBox: TextBox;
}

export const Underline = ({ textBox }: UnderlineProps) => {
    const { isActive, handleClick } = useUnderline(textBox);
    return (
        <div
            className={`w-20 h-10 grid place-items-center ${
                isActive ? "bg-irGray-200 dark:bg-darkSurface-100" : "bg-transparent hover:bg-irGray-100 dark:hover:bg-darkSurface-300"
            } rounded-lg border border-[#dfe0e2] dark:border-darkSurface-400`}
            onClick={handleClick}
        >
            <UnderlineIcon />
        </div>
    );
};
